import { Provider } from '@angular/core';
import { ProcessDesignerUIState } from './app/process-designer.uistate';
import { ProcessDesignerViewModel } from './app/process-designer.viewmodel';
import { ProcessDesignerDataService } from './domain/process-designer.dataservice';
import { BpmnProcessViewModel } from './app/bpmn-process.viewmodel';
import { WFFlowElementsViewModel } from './app/wf-flowElements.viewModel';
import { SubProcessViewModel } from './app/sub-process.viewmodel';
import { AutoActivityAdapter } from './app/auto-activity.adapter';
import { CatchEventAdapter } from './app/catch-event.adapter';
import { MessageActivityAdapter } from './app/message-activity.adapter';
import { NotifyActivityAdapter } from './app/notify-activity.adapter';
import { AifCreationBillActivityAdapter } from './app/aif-creation-bill-activity.adapter';
import { BillNodeActivityAdapter } from './app/bill-node-activity.adapter';
import { SequenceActivityAdapter } from './app/sequecne-activity.adapter';

const PROCESS_DESIGNER_APP_PROVIDERS: Provider[] = [
    ProcessDesignerUIState,
    ProcessDesignerViewModel,
    BpmnProcessViewModel,
    WFFlowElementsViewModel,
    SubProcessViewModel,
    AutoActivityAdapter,
    CatchEventAdapter,
    MessageActivityAdapter,
    NotifyActivityAdapter,
    AifCreationBillActivityAdapter,
    BillNodeActivityAdapter,
    SequenceActivityAdapter,
];
export {
    ProcessDesignerUIState,
    ProcessDesignerViewModel,
    BpmnProcessViewModel,
    WFFlowElementsViewModel,
    SubProcessViewModel,
    AutoActivityAdapter,
    CatchEventAdapter,
    MessageActivityAdapter,
    NotifyActivityAdapter,
    AifCreationBillActivityAdapter,
    BillNodeActivityAdapter,
    SequenceActivityAdapter,
    PROCESS_DESIGNER_APP_PROVIDERS,
};
const PROCESS_DESIGNER_DOMAIN_PROVIDERS: Provider[] = [
    ProcessDesignerDataService
];
export {
    ProcessDesignerDataService,
    PROCESS_DESIGNER_DOMAIN_PROVIDERS
};
const PROCESS_DESIGNER_PART_PROVIDERS: Provider[] = [
];
export {
    PROCESS_DESIGNER_PART_PROVIDERS
};
